module.exports = __webpack_public_path__ + "static/img-web-dev-f4b1e0bc669ed546e1438e88a85205e0.png";